<template>
  <nav
    class="breadcrumbs"
    :class="{ [$class('loading')]: state === 'loading' }"
    :aria-label="$string('general.breadcrumbs.label')"
  >
    <ol class="breadcrumbs__list-element">
      <li class="breadcrumbs__list-item">
        <a
          class="breadcrumbs__link text-other-label-s"
          :href="$variable('routes.root')"
          v-text="$string('general.breadcrumbs.home')"
        />

        <span
          class="text-other-label-s"
          aria-hidden="true"
          v-text="$string('general.breadcrumbs.separator')"
        />
      </li>

      <li
        v-if="ancestorTitle && ancestorUrl"
        class="breadcrumbs__list-item"
      >
        <a
          class="breadcrumbs__link text-other-label-s"
          :href="ancestorUrl"
          v-text="ancestorTitle"
        />

        <span
          class="text-other-label-s"
          aria-hidden="true"
          v-text="$string('general.breadcrumbs.separator')"
        />
      </li>

      <li class="breadcrumbs__list-item">
        <span
          class="breadcrumbs__link text-other-label-s"
          :style="{ animationDelay: animationDelay }"
          v-text="title"
        />
      </li>
    </ol>
  </nav>
</template>

<script>

/**
 * Vue: Breadcrumbs (breadcrumbs)
 * -----------------------------------------------------------------------------
 * Breadcrumbs navigation links.
 *
 * @param {String} ancestorTitle - Title of ancestor, e.g. collection title if
 * product is in a collection.
 * @param {String} ancestorUrl - URL of ancestor, this avoids complicating the
 * breadcrumb component by making additional queries to load ancestor data.
 * @param {String} state - Loading state of parent component.
 * @param {String} title - Title displayed for current page.
 *
 */
import { values as timings } from '~/config/timings'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Breadcrumbs',

  props: {
    ancestorTitle: {
      type: String,
      default: '',
    },
    ancestorUrl: {
      type: String,
      default: '',
    },
    state: {
      type: String,
      default: 'loading',
    },
    title: {
      type: String,
      default: '',
    },
  },

  computed: {

    /**
     * Compute animation delay.
     * @returns {Boolean|String}
     */
    animationDelay() {
      return this.ancestorTitle && this.ancestorUrl
        ? `${timings.quick}s`
        : false
    },
  },
}
</script>

<style lang="scss">
@import './breadcrumbs';
</style>
